export function queryString (search) {
  const query = {}
  if (search) {
    const params = search.substring(1).split('&')
    params.forEach(item => {
      const kv = item.split('=')
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1])
      }
    })
  }
  return query
}

export function getEnv () {
  if (/(staging|localhost|127\.0\.0\.1|192\.168\.)/.test(window.location.href)) {
    return 'staging'
  } else {
    return 'production'
  }
}

export function visibilityChange (cb) {
  document.addEventListener('visibilitychange', () => {
    cb(document.hidden)
  }, false)
}

export function shuffle (array) {
  let m = array.length
  while (m) {
    const i = Math.floor(Math.random() * m--)
    const t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}

export function isEmptyObject (obj) {
  return typeof obj === 'object' && Object.keys(obj).length === 0
}

export default {
  queryString,
  shuffle,
  getEnv,
  visibilityChange,
  isEmptyObject
}



// WEBPACK FOOTER //
// ./src/utils.js